import { ICreateCentroCustoEnderecoUseCase } from "../../../presentation/useCases/create/create_centro_custo_endereco_use_case";
import { CentroCustoEndereco } from "../../models/centro_custo_endereco";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * CreateCentroCustoEnderecoUseCase
 */

export class CreateCentroCustoEnderecoUseCase implements ICreateCentroCustoEnderecoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async createCentroCustoEndereco(form: CentroCustoEndereco): Promise<CentroCustoEndereco> {
    const result = await this.repository.createCentroCustoEndereco(form);
    return result;

  }

}
